/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Role status */
export enum RoleStatus {
  Active,
  Inactive,
  Deprecated,
  UnderReview,
  Suspended,
}

export type RoleStatusArgs = RoleStatus;

export function getRoleStatusEncoder(): FixedSizeEncoder<RoleStatusArgs> {
  return getEnumEncoder(RoleStatus);
}

export function getRoleStatusDecoder(): FixedSizeDecoder<RoleStatus> {
  return getEnumDecoder(RoleStatus);
}

export function getRoleStatusCodec(): FixedSizeCodec<
  RoleStatusArgs,
  RoleStatus
> {
  return combineCodec(getRoleStatusEncoder(), getRoleStatusDecoder());
}
